<ng-container *ngFor="let item of list">
  <a [routerLink]="['/network-group', item.virtId]"
     class="list-group-item transition item-sub sub"
     data-parent="#menu0sub1" >
    {{item.name}}
  </a>
</ng-container>
